import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

Vue.prototype.axios = axios
Vue.config.productionTip = false
//IE includes 대응
String.prototype.includes = function (str) {
  var returnValue = false;
  if (this.indexOf(str) !== -1) {
    returnValue = true;
  }
  return returnValue;
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
